import { render, staticRenderFns } from "./scheduleEdit_physio.vue?vue&type=template&id=67cbc579&scoped=true"
import script from "./scheduleEdit_physio.vue?vue&type=script&lang=js"
export * from "./scheduleEdit_physio.vue?vue&type=script&lang=js"
import style0 from "./scheduleEdit_physio.vue?vue&type=style&index=0&id=67cbc579&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cbc579",
  null
  
)

export default component.exports